import { LoginBaseModel } from './login-base-model';

export class BiodigitalLoginModel extends LoginBaseModel {
    constructor (
        public email: string,
        public password: string,
        public rememberMe: boolean
    ) {
        super();
    }

    static toJSON(value: BiodigitalLoginModel): any {
        return {
            id_token: value.token, 
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode,
            email: value.email, 
            password: value.password,
            email_remember_me: value.rememberMe
        };
    }
}
